import React, { Suspense } from "react";
import {
  Box,
  Button,
  Dialog,
  FabButton,
  Flex,
  Gap,
  InputField,
  Typography,
} from "../../../ppui";
import {
  ContentHeading,
} from "../../style";
import { Checkbox } from "../../../ppui";
import useHolidayService from "./use-holiday-service";
import { HOLIDAY_INPUT_FIELDS } from "./holiday-constant";
import HolidayList from "./holiday-list";
import ErrorBoundary from "../../../utils/error-boundary";
import { Snackbar } from "../../../ppui/snackbar";
import { TbPencil } from "react-icons/tb";

function HolidayManagement() {

  

  const {
    open
    , handleClickOpen 
    , handleClose,
    handleSubmitFn,
    getInputFieldPropsFn,
    hanldeAddAnotherFn,
    addAnother,
    resource,
    snackbarVisible,
    snackbarMessage,
    closeSnackbar,
    snackColor,
    handleEditModalOpen,
    esiInputs
  }=useHolidayService();


  return (
    <>
     
        <ContentHeading>
          <Typography variant="h5" mb="0">
            Holiday Management
          </Typography>

       
          <FabButton
          size="sm"
          icon={<TbPencil />}
          onClick={()=>handleClickOpen()}
          variant="filled"
          shape="box"
        />
        </ContentHeading>

        
         
    
         
  <ErrorBoundary
        fallback={<p>Something went wrong in fetching BankList...</p>}
      >
        <Suspense fallback={<p>Loading BankList...</p>}>
            <HolidayList resource={resource} handleEditModalOpen={handleEditModalOpen}  />
        </Suspense>
        </ErrorBoundary>
        
          <Gap height={100} />
          <Flex justifyContent="flex-end" gap={"10"}>
            <Button onClick={() => {}} variant="outlined" disabled>
              Cancel
            </Button>
            <Button color="primary" onClick={() => {}} variant="contained">
              Save
            </Button>
          </Flex>
    
 

      {/* Modal */}
      <Dialog
        title={`${esiInputs?.holidayId ? "Update" : "Create"} Holiday`}
        closeButton={true}
        fullWidth
        maxWidth="xs"
        buttonName={"Save"}
        open={open}
        onClose={handleClose}
        onSubmit={handleSubmitFn}
        separator
        footer={
          !esiInputs?.holidayId &&   <Box mr={"auto"}>
              <Checkbox
                size="sm"
                color="primary"
                label="Another Holiday"
                onChange={hanldeAddAnotherFn}
    checked={addAnother}
              />
            </Box>
        }
      >
        <Flex direction="column" width={"100%"} gap={"20"}>
          <InputField
            // fullWidth
            // label="Holiday Name"
            // placeholder="Type Here..."
            // type="number"
            {...getInputFieldPropsFn(HOLIDAY_INPUT_FIELDS.holidayName.name)}

          />

          <InputField
            // fullWidth
            // label="Date"
            // placeholder="Select Here..."
            // type="date"
            // valueSinc={"true"}
            {...getInputFieldPropsFn(HOLIDAY_INPUT_FIELDS.holidayDate.name)}
            onK

          />

          
        </Flex>
      </Dialog>
      {/* Modal */}

      <Snackbar
        message={snackbarMessage}
        color={snackColor}
        variant="contained"
        size="medium"
        position="top-right"
        onClose={closeSnackbar}
        onOpen={snackbarVisible}
        loading={false}
        duration={3000}
      />
    </>
  );
}

export default HolidayManagement;
